import React from "react";
import Box from "ReusableComponents/Box";
import H1 from "ReusableComponents/Text/H1";
import Span from "ReusableComponents/Text/Span";
import { COLORS, SIZES } from "theme";

const AboutUsOverlay = ({ data, small }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      position="absolute"
      bottom="0"
      left="0"
      zIndex="2"
      h="-webkit-fill-available"
      w="-webkit-fill-available"
      background="linear-gradient(to right, rgba(0,0,0,0.65) 0%,rgba(0,0,0,0) 100%)"
      justifyContent="flex-end"
    >
      <Box margin={small ? "40px" : "0 80px"}>
        <Box>
          <Box w={small ? "100%" : "60%"} marginBottom={small ? 0 : "40px"}>
            <Box marginBottom="2rem">
              <H1
                w="fit-content"
                display="flex"
                flexDirection="column"
                marginBottom={small ? SIZES.twelve : SIZES.twenty}
              >
                <Span
                  fontSize={small ? SIZES.twentyFour : SIZES.forty}
                  w="fit-content"
                  textAlign="center"
                  textColor="white"
                  background={COLORS.black}
                  fontWeight="bold"
                  padding={small ? "0.2em" : "0.3em"}
                >
                  {data?.attributes?.title}
                </Span>

                <Span
                  fontSize={small ? SIZES.twentyFour : SIZES.forty}
                  padding={small ? "0.2em" : "0.3em"}
                  background={COLORS.black}
                  textColor="white"
                  w="fit-content"
                  fontWeight="bold"
                  textAlign="center"
                  marginLeft="1em"
                >
                  {data?.attributes?.subtitle}
                </Span>
              </H1>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AboutUsOverlay;
